/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContractSummaryDto } from './ContractSummaryDto';
import {
    ContractSummaryDtoFromJSON,
    ContractSummaryDtoFromJSONTyped,
    ContractSummaryDtoToJSON,
    ContractSummaryDtoToJSONTyped,
} from './ContractSummaryDto';

/**
 * 
 * @export
 * @interface GetSummaryContractListResponse
 */
export interface GetSummaryContractListResponse {
    /**
     * 
     * @type {number}
     * @memberof GetSummaryContractListResponse
     */
    totalCount: number;
    /**
     * 
     * @type {Array<ContractSummaryDto>}
     * @memberof GetSummaryContractListResponse
     */
    items: Array<ContractSummaryDto>;
}

/**
 * Check if a given object implements the GetSummaryContractListResponse interface.
 */
export function instanceOfGetSummaryContractListResponse(value: object): value is GetSummaryContractListResponse {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetSummaryContractListResponseFromJSON(json: any): GetSummaryContractListResponse {
    return GetSummaryContractListResponseFromJSONTyped(json, false);
}

export function GetSummaryContractListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSummaryContractListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(ContractSummaryDtoFromJSON)),
    };
}

export function GetSummaryContractListResponseToJSON(json: any): GetSummaryContractListResponse {
    return GetSummaryContractListResponseToJSONTyped(json, false);
}

export function GetSummaryContractListResponseToJSONTyped(value?: GetSummaryContractListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(ContractSummaryDtoToJSON)),
    };
}

